import React from 'react';
import { Tabs } from 'antd';
import HackLogTab from './HackLogTab';
import LevelAbuseDetectionTab from './LevelAbuseDetectionTab';
import IpMonitoring from "./IpMonitoring";
import BanLog from "../../features/logs/BanLog"; // [수정] import 경로 및 이름 변경

const Hack = () => {
    const items = [

        {
            key: '1',
            label: '레벨 어뷰징 감지', // [수정] 탭 이름 변경
            children: <LevelAbuseDetectionTab />, // [수정] 컴포넌트 변경
        },
        {
            key: '2',
            label: 'IP 모니터링 관리',
            children: <IpMonitoring />,
        },
        {
            key: '3',
            label: '핵 감지 로그',
            children: <HackLogTab />,
        },
        {
            key: '4',
            label: '유저 제재 로그',
            children: <BanLog />
        }
    ];

    return (
        <Tabs defaultActiveKey="1" type="card" items={items} />
    );
};

export default Hack;